/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { Client } from 'fierry/flux';

import ShapeEnum, { getShapeToCount } from 'shared/enum/shape';

import Galaxy from 'shared/query/galaxy';
import Navigation from 'shared/client/navigation';

import * as Coords from 'shared/geo/coords';
import * as Topological from 'fierry/util/topological';


export default new Client([ Navigation, Galaxy ], class
{
  constructor (navigation, galaxy)
  {
    this.galaxy = galaxy;
    this.navigation = navigation;

    this.source = navigation.getCurrent();
    this.targets = navigation.getTargetsRepresentation();
  }


  onDone ()
  {
    this.galaxy.setZoneDirections(this.source, this.__getChanges__());
  }


  __getChanges__ ()
  {
    let changes = [];

    for (const target of this.targets)
    {
      changes.push({ location: target.location.getCass(), value: target.value });
    }

    return changes;
  }


  getError ()
  {
    if (this.targets.length == 0)
    {
      return null;
    }

    for (const target of this.targets)
    {
      const distance  = Coords.getDistance(this.source.getCoords(), target.location.getCoords());

      if (distance != 1)
      {
        return 'Please select your immediate neighbors as targets.';
      }
    }

    if (this.__hasCycle__())
    {
      return 'Cycle in zone-flows has been found.'
    }

    return null;
  }


  __hasCycle__ ()
  {
    const getDirectionsCallback = (zone) =>
    {
      const directions = zone.getDirections().getOutgoingWithNavigation(this.navigation);

      return zone.getDirections().getZones(directions);
    };

    return Topological.hasCycle(this.source.getPlanet().getZones(), getDirectionsCallback);
  }


});
